// The strip on the right of a workspace page that holds the round Wingman bubble while
// the docked chat is closed (Lane 1387). Ryan, 2026-10-05: "I do like the floating
// bubble ... it just needs to be in the right spot". On a sourcing event the fixed bubble
// covered the Suppliers card's chips when the page opened (Lane 1372: space under the
// last card only helped after scrolling), and Lane 1382's header buttons replaced it. So
// the bubble is back, in a column of its own: the page keeps this strip free at its right
// edge while the chat is closed, and the bubble sits at the strip's foot. Nothing of the
// page is ever under it, at any width or scroll position.
//   * Chat closed: the strip and its bubble show; a click opens the chat.
//   * Chat open: no strip and no bubble; the chat's own X (or Escape) closes it, and the
//     bubble comes back.
// Focus: opening moves focus to the chat's message box, closing brings it back to the
// bubble (as Lane 1382's header button did). A page that moves focus itself (the deck
// chat) passes manageFocus={false}. `controls`: the id of the dock that holds the chat.
import React, { forwardRef, useEffect, useImperativeHandle, useRef } from 'react';
import ChatBubble from './ChatBubble';
import focusChat from './focusChat';
import '../../pages/ListLinear.css';     // the palette tokens (declared on .ll and .wchat)
import './workspaceChat.css';

const ChatRail = forwardRef(function ChatRail({ open, onOpen, controls, manageFocus = true }, ref) {
  const bubbleRef = useRef(null);
  useImperativeHandle(ref, () => bubbleRef.current);
  // Only on a change of `open` after the first render, so opening the page never moves
  // focus.
  const wasOpen = useRef(open);
  useEffect(() => {
    if (wasOpen.current === open) return;
    wasOpen.current = open;
    if (!manageFocus) return;
    if (open) {
      focusChat(document.getElementById(controls));
    } else if (bubbleRef.current) {
      bubbleRef.current.focus();
    }
  }, [open, controls, manageFocus]);
  if (open) return null;
  return (
    <div className="wchat wchat-rail" data-testid="wchat-rail">
      <ChatBubble ref={bubbleRef} open={false} onToggle={onOpen} controls={controls} />
    </div>
  );
});

export default ChatRail;
